import React, { Component } from "react";
import { connect } from "react-redux";

import { Link, useMatch, useNavigate } from "../utils/components/router";
import Timeout from "../utils/components/Timeout";
import { basketActions, messageActions, configActions } from "../actions";
import CONFIG from "../config";
import { checkResize } from "../utils/functions";
import { ArrowBackIcon, ArrowForwardIcon, CloseIcon } from "../utils/components/icons";
import DetailImage from "../partial/metals/DetailImage";
import { PartialMessage, BackToStartButton } from "../partial";

class EmpfehlungMA extends Component {
  constructor(props) {
    super(props);
    this.addToWarenKorb = this.addToWarenKorb.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  state = {
    item: null
  };

  componentDidMount() {
    checkResize();
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.metalsStorage || !Array.isArray(props.metalsStorage.current))
      return;
    let item = props.metalsStorage
      .getItems()
      .find((metals) => metals.id === "nm" + props.params.id);
    if (item &&
      (
        (
          state.item &&
          state.item.kennziffer !== item.kennziffer
        ) ||
        state.item === null
      )
    ) {
      return { item: item.clone() };
    }
    return null;
  }

  addToWarenKorb(e) {
    let currentItem = this.state.item;
    const itemPrice = currentItem.brutto.getPrice();
    const basketSum = this.props.basketStorage.sum.getPrice() + itemPrice;

    if (
      this.props.basketStorage.isPriceTooHigh(itemPrice) &&
      !this.props.configStorage.isAnkaufShop()
    ) {
      let message =
        "Der Gegenwert übersteigt die Obergrenze von " +
        this.props.basketStorage.getMaxSumText() +
        " Euro. Bitte reduzieren Sie den Gegenwert.";
      this.props.dispatch(
        messageActions.showMessage(
          this.props.configStorage.getHtmlId(),
          ".ser-commit",
          message
        )
      );
      e.preventDefault();
    } else if (
      this.props.basketStorage.isPriceTooHigh(basketSum) &&
      !this.props.configStorage.isAnkaufShop()
    ) {
      let message =
        "Mit diesem Produkt übersteigt Ihr Warenkorb die Obergrenze von " +
        this.props.basketStorage.getMaxSumText() +
        " Euro. Bitte reduzieren Sie die gewählte Menge oder entfernen Sie Produkte aus Ihrem Warenkorb.";
      this.props.dispatch(
        messageActions.showMessage(
          this.props.configStorage.getHtmlId(),
          ".ser-commit",
          message
        )
      );
      e.preventDefault();
    } else {
      this.props.dispatch(basketActions.addItem(currentItem.clone()));
      if (this.props.configStorage.sessionWillEnd()) {
        this.props.dispatch(configActions.resetSession(this.props.configStorage.getRequestData("session_ping")));
      }
    }
  }

  handleOnChange(value) {
    let item = this.state.item;
    item.changeAmount(value);
    this.setState({ item });
  }

  render() {
    let item = this.state.item;
    if (!item) {
      return (
        <div className="bootstrap-iso">
          <div className="container bg-white pt-one pb-one h-100">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header justify-content-end">
                  <button
                    type="button"
                    className="close btn btn-default"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() =>
                      this.props.navigate(
                        this.props.configStorage.getBackToShopLink()
                      )
                    }
                  >
                    <CloseIcon />
                  </button>
                </div>
                <div className="modal-body">
                  <h3 className="text-gray">
                    Entschuldigung, dieser Artikel ist derzeit nicht verfügbar!
                  </h3>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() =>
                      this.props.navigate(
                        this.props.configStorage.getBackToShopLink()
                      )
                    }
                  >
                    Zur Übersichtsseite
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    const isBasketFull = this.props.basketStorage.isBasketFull();    
    return (
      <section id={CONFIG.SHOP_ID} className="bootstrap-iso">
        <h1 className="aria-visible">Produktdetails</h1>
        <div className="container" >
          <h2 className="col-8 col-md-6 col-lg-12 text-h2-secondary" >
            {item.name}
          </h2>
          {item.produktInfo ? (
            <div className="ps-3" aria-label="Produktinfo">
              <span className="f-small text-wrap">{item.produktInfo}</span>
            </div>
          ) : null}
          <Timeout />
          <div className="row bg-white bm-1 pb-1 pt-1 ser-detail">
            <DetailImage item={item} handleOnChange={this.handleOnChange} />
            <PartialMessage />
          </div>
          <div className="row justify-content-between mt-one mb-one">
            <button
              type="button"
              className="ser-back btn-link justify-content-start"
              onClick={() =>
                this.props.navigate(
                  this.props.configStorage.getBackToShopLink()
                )
              }
            >
              <ArrowBackIcon />
              {isBasketFull ? "Zurück" : "Abbrechen"}
            </button>
            <BackToStartButton />
        {!this.props.configStorage.isLightShop() ?
              (!isBasketFull ? (
                <Link
                  onClick={this.addToWarenKorb}
                  className="ser-commit btn-primary justify-content-end"
                  to={this.props.configStorage.getBackToShopLink()}
                >
                  In den Warenkorb
                  <ArrowForwardIcon />
                </Link>
              ) : (
                <button
                  className="btn btn-info justify-content-end col-auto"
                  onClick={() =>
                    this.props.navigate(
                      this.props.configStorage.getBackToShopLink()
                    )
                  }
                >
                  {this.props.configStorage.isAnkaufShop() ? (
                    <span>
                      Ein Ankauf von mehr als{" "}
                      {this.props.basketStorage.getMaxBasketSize()} Position pro
                      Warenkorb ist nicht möglich.
                    </span>
                  ) : (
                    <span>
                      Eine Bestellung über{" "}
                      {this.props.basketStorage.getMaxBasketSize()} Edelmetalle je
                      Warenkorb ist nicht möglich.
                    </span>
                  )}
                </button>
              )) 
              : null 
            }
          </div>
        </div>
      </section>
    );
  }
}
export default connect((store) => {
  return {
    basketStorage: store.basketStorage,
    metalsStorage: store.metalsStorage,
    configStorage: store.configStorage,
  };
})((props) => {
  const match = useMatch() || {};
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return (
    <EmpfehlungMA
      params={match.params || {}}
      navigate={contextNavigate}
      {...props}
    />
  );
});
